var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C24.822 0 32 7.178 32 16C32 24.822 24.822 32 16 32C7.178 32 0 24.822 0 16C0 7.178 7.178 0 16 0ZM16 2C8.28 2 2 8.28 2 16C2 23.72 8.28 30 16 30C23.72 30 30 23.72 30 16C30 8.28 23.72 2 16 2ZM13.77 11.486C13.888 11.486 14.004 11.516 14.106 11.576L20.757 15.416C20.8596 15.4753 20.9448 15.5605 21.004 15.6631C21.0632 15.7657 21.0944 15.882 21.0944 16.0005C21.0944 16.119 21.0632 16.2353 21.004 16.3379C20.9448 16.4405 20.8596 16.5257 20.757 16.585L14.107 20.424C14.0045 20.484 13.888 20.5158 13.7692 20.5162C13.6505 20.5166 13.5337 20.4856 13.4309 20.4263C13.328 20.3669 13.2426 20.2815 13.1835 20.1785C13.1243 20.0755 13.0934 19.9588 13.094 19.84V12.16C13.094 11.788 13.397 11.486 13.769 11.486H13.77Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLarge);
export default __webpack_public_path__ + "static/media/playLarge.3d05189e962b37120348faade1ccbc9f.svg";
export { ForwardRef as ReactComponent };